
export class ColaboradorPuesto {
    puestoporcolaboradorid: number = 0;
    colaboradorid: number = 0;
    puestoid: number[] = [];
    fechaasignado: string = "";


    constructor(init?: Partial<ColaboradorPuesto>) {
        Object.assign(this, init);
    }
}
